import React, { useState } from 'react';
import Image from 'next/image';
import {
  LeftSwipperArrows,
  RightSwipperArrows
} from '../../shared-components/SwipperArrows/SwipperArrows';

interface Blog {
  writer: string;
  publicationDate: string;
  page_title: string;
  subheader: string;
  image: { alt_text: string; image: string };
  slug: string;
}

interface BlogSwiperSectionProps {
  selected_blogs: Blog[];
}

const BlogSwiperSection: React.FC<BlogSwiperSectionProps> = ({
  selected_blogs
}) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleNext = () => {
    if (currentSlide < selected_blogs.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const handlePrev = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  return (
    <div
      className="absolute bottom-0 xxsm:right-[5%] xmsm:right-[6%] xsm:right-[7%] mxsm:right-[8%] msm:right-[9%] mmsm:right-[10%]
                  sm:right-[11%] md:right-[5%] xl:right-[12%] translate-y-[57%] bg-white rounded-lg w-[190px] h-[280px] md:w-[280px] md:h-[360px] xl:w-[436px] xl:h-[540px] xl:translate-y-[45%]"
    >
      <div className="w-full h-[50%] rounded-t-lg p-2 md:h-1/2">
        <Image
          src={selected_blogs[currentSlide].image?.image}
          alt={selected_blogs[currentSlide].image?.alt_text || 'Blog Image'}
          width={1920}
          height={1080}
          className="object-cover w-full h-full rounded-lg"
        />
      </div>

      <div className="w-full h-[50%] flex flex-col md:h-1/2 rounded-b-lg">
        <div className="text-primary w-full text-[12px] md:text-[15px] text-right ml-4 pr-6 lg:mt-4 xl:text-[18px]">
          {formatDate(selected_blogs[currentSlide]?.publicationDate)}
        </div>

        <div className="text-primary w-full text-[15px] md:text-[20px] text-left font-bold ml-4 pr-6 xl:text-[32px] flex-grow">
          {selected_blogs[currentSlide]?.page_title}
        </div>

        <div className="flex flex-row justify-between ml-4 mt-2 mb-2 lg:mb-6">
          <div className="mr-2 mt-4 text-[12px]">
            <div className="flex gap-2">
              {selected_blogs?.map((_, index) => (
                <div
                  key={index}
                  className={`w-2.5 h-2.5 rounded-full ${
                    currentSlide === index ? 'bg-[#ff4545]' : 'bg-gray-400'
                  }`}
                ></div>
              ))}
            </div>
          </div>

          <div id="slider-btn" className="flex justify-center mt-0 mr-3">
            <div className="flex gap-2 justify-center items-center">
              <div className="prevSlide cursor-pointer" onClick={handlePrev}>
                <LeftSwipperArrows isFirstSlide={currentSlide === 0} />
              </div>
              <div className="nextSlide cursor-pointer" onClick={handleNext}>
                <RightSwipperArrows
                  isLastSlide={currentSlide === selected_blogs.length - 1}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogSwiperSection;
